var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2b3e5b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29,8.5a2,2,0,0,0-2-2H13a2,2,0,0,0,0,4H27A2,2,0,0,0,29,8.5Z",
    transform: "translate(11 6.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,11a2,2,0,0,0,0,4h8a2,2,0,0,0,0-4Z",
    transform: "translate(11.5 11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.828,6,36,1.17A4,4,0,0,0,33.172,0H10A4,4,0,0,0,6,4V18.55a.5.5,0,0,0,.484.5c.732.012,2.076.068,2.97.166a.492.492,0,0,0,.546-.5V5a1,1,0,0,1,1-1H32.758a1,1,0,0,1,.706.292l4.244,4.244A1,1,0,0,1,38,9.242V36a1,1,0,0,1-1,1H23.284a.49.49,0,0,0-.482.42,15.912,15.912,0,0,1-.728,2.916A.488.488,0,0,0,22.53,41H38a4,4,0,0,0,4-4V8.83A4,4,0,0,0,40.828,6Z",
    transform: "translate(6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,11A13,13,0,1,0,26,24,13,13,0,0,0,13,11Zm5,14.5H15a.5.5,0,0,0-.5.5v3a1.5,1.5,0,0,1-3,0V26a.5.5,0,0,0-.5-.5H8a1.5,1.5,0,0,1,0-3h3a.5.5,0,0,0,.5-.5V19a1.5,1.5,0,0,1,3,0v3a.5.5,0,0,0,.5.5h3a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0 11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.55bde34b1a93a15197d4478f9ba6ec46.svg";
export { ForwardRef as ReactComponent };